import HeaderNavbar from './headerNavbar'

const headerNavbar = new HeaderNavbar()
headerNavbar.init()
